import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'connected-app box',

    events: {
        'click .reconnect' : 'onReconnect',
        'click .rename'    : 'onRename',
        'click .delete'    : 'onDelete'
    },

    dom_handlers: {
        onReconnect: function() {
            Modals.reconnectConnectedApp('trello', this.model);
        },

        onRename: function() {
            Modals.renameConnectedApp('trello', this.model);
        },

        onDelete: function() {
            Modals.removeConnectedApp('trello', this.model);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    loadUsage: function() {
        Cache.app.request({
            action: 'integration/getConnectedAppUsage',
            data: {
                app_id   : this.model.id,
                app_type : 'trello'
            },
            success: (response) => {
                this.model.set('integration_total', response.integration_total);
            }
        });
    },

    render: function() {
        var is_usage_loaded = typeof this.model.get('integration_total') !== 'undefined';
        var creator = Cache.user.get(this.model.get('creator_id'));

        var content =
        '<div><img class="app-logo" src="/image/trello_small.png"></div>' +
        '<div>' +
            '<div class="app-name">' + this.model.escape('custom_name') + '</div>' +
            '<div class="app-connect-time">' +
                '<span>Connected on: <b>' + Util.moment(this.model.get('create_time'), 'DD MMM YYYY hh:mm A') + '</b></span>' +
                (this.model.get('is_disabled') ?
                '<span class="badge-warning-invert badge-small tooltip" data-title="Authentication failed. Please reconnect your Trello account."><i class="fa-solid fa-circle-exclamation"></i> Disabled</span>' : '') +
            '</div>' +
            '<div class="app-connect-by">' +
                '<span>Connected by: ' + (creator ? creator.escape('name') : 'Unknown') + '</span>' +
            '</div>' +
            '<div class="app-usage">' +
            '<span>Used in <b>' + (is_usage_loaded ? this.model.escape('integration_total') : '<i class="fa-solid fa-spinner-third fa-spin fa-xs"></i>') + '</b> integration' + (this.model.get('integration_total') === 1 ? '' : 's') + '</span>' +
            '</div>' +
            '<div class="app-action">' +
                '<div class="button-dropdown">' +
                    '<button class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                    '<div>' +
                        '<ul class="dropdown">' +
                            '<li class="reconnect">Reconnect</li>' +
                            '<li class="rename">Rename</li>' +
                            '<li class="separator"></li>' +
                            '<li class="delete danger">Delete</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        if (!is_usage_loaded) {
            this.loadUsage();
        }

        return this;
    }
});